module.exports = __webpack_public_path__ + "static/img/dd-banner-06.8785da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-06.png
// module id = pL9O
// module chunks = 1